import { AuthGuardService } from '../services/auth-guard.service';

import { DashboardView } from '../views/dashboard/dashboard.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AssetStatsComponent } from './asset.stats/asset.stats.component';
import { GuiStatsComponent } from './gui.stats/gui.stats.component';
import { VendorStatsComponent } from './vendor.stats/vendor.stats.component';


const SoftwareStatsRouting: Routes = [
    // login view
    {

        path: 'software-stats', canActivate: [AuthGuardService], component: DashboardView,
        children: [
            { path: '', component: AssetStatsComponent },
            { path: 'assets', component: AssetStatsComponent },
            { path: 'gui', component: GuiStatsComponent },
            { path: 'vendors', component: VendorStatsComponent },
            // handle all other routes
            { path: '**', component: AssetStatsComponent }
        ]
    },
];


@NgModule({
    imports: [RouterModule.forChild(SoftwareStatsRouting)],
    exports: [RouterModule]
})
export class SoftwareStatsRoutingModule { }
